import tenantUtils from '@utils';
import { NetworkService } from '../../../../services/networkService';
import { TIME_DATE_FORMAT } from '../../../../constants/formats';
import { getTimeDateString } from '../../../../utility/date';

export const getTasksSubTypes = async (taskId, taskTypeId) => {
  const response = await NetworkService.get(
    `/api/task_purposes?q[task_type_id_eq]=${taskId}&q[category_eq]=${taskTypeId}`,
  );
  if (response?.error) {
    return response;
  } else {
    return response?.data?.task_purposes;
  }
};
